import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { ADMIN_API, COLOR_OPTION, THEME_OPTION } from "../../../common/common";

import {
  MOBILE_FOOTER_OPTIONS,
  normalizeMobileFooterId,
  DEFAULT_MOBILE_FOOTER,
} from "../../../common/mobileFooter";
import {
  MOBILE_HEADER_OPTIONS,
  normalizeMobileHeaderId,
  DEFAULT_MOBILE_HEADER,
} from "../../../common/mobileHeader";
import {
  AG_LOGIN_DESIGN_OPTIONS,
  LOGIN_SUPPORT_STYLE_OPTIONS,
  normalizeAgLoginDesign,
  normalizeLoginSupportStyle,
  DEFAULT_LOGIN_SUPPORT_STYLE,
} from "../../../common/loginPage";

import { Logout } from "../../../common/Funcation";
import {
  styleObjectBlackButton,
  getTheme,
  hexToYIQTextColor,
} from "../../../common/StyleSeter";
import ImageUpload from "../../../components/ImageUpload";
import { notifyError, notifyMessage, postApi } from "../../../service";
import { COLOR_OPTION_INTERFACE, WebSiteList } from "../interface";

const WEBSITE_EDIT_SECTIONS = [
  { id: "basic", label: "Site Basic Information" },
  { id: "header", label: "Header" },
  { id: "login-images", label: "Login Images" },
  { id: "sports", label: "Sports Banner" },
  { id: "velki", label: "Velki Theme Images" },
  { id: "ag", label: "AG Panel" },
  { id: "mobile-header", label: "Mobile Header" },
  { id: "mobile-footer", label: "Mobile Footer" },
  { id: "buttons", label: "Buttons & Banners" },
  { id: "login", label: "Login Page" },
  { id: "messages", label: "Messages" },
] as const;

type WebsiteEditSectionId = (typeof WEBSITE_EDIT_SECTIONS)[number]["id"];

const SECTION_REQUIRED_FIELDS: Partial<
  Record<WebsiteEditSectionId, string[]>
> = {
  basic: ["title", "domain", "currency"],
  header: ["headerSchema", "favicon", "logo"],
  "login-images": ["loginImage", "mobileLoginImage"],
};

const IMAGE_FIELD_SECTION: Record<string, WebsiteEditSectionId> = {
  favicon: "header",
  logo: "header",
  loginImage: "login-images",
  mobileLoginImage: "login-images",
};

const readSavedSection = (websiteId?: string): WebsiteEditSectionId => {
  try {
    const saved = sessionStorage.getItem(
      `website-edit-section:${websiteId || "new"}`,
    );
    if (WEBSITE_EDIT_SECTIONS.some((item) => item.id === saved)) {
      return saved as WebsiteEditSectionId;
    }
  } catch (error) {
    return "basic";
  }
  return "basic";
};

function EditWebsites(this: any) {
  const [formData, setFormData] = useState<WebSiteList | any>({
    colorSchema: COLOR_OPTION[0].value,
    headerSchema: "",
    adminHeaderSchema: "",
    adminHeaderTextColor: "",
    adminNavSchema: "",
    adminNavTextColor: "",
    mobileHeaderSchema: "",
    mobileHeader: DEFAULT_MOBILE_HEADER,
    mobileFooter: "games-six",
    mobileFooterSchema: "",
    mobileFooterActiveColor: "",
    mobileEventTypeSchema: "",
    mobileEventTypeTextColor: "",
    matchListTextColor: "",
    playNowButtonColor: "",
    inplayCricketBanner: true,
    inplayCricketBannerImage: "",
    loginPageBgColor: "",
    loginButtonColor: "",
    mobileLoginButtonColor: "",
    loginButtonTextColor: "",
    loginDownloadButtonColor: "",
    placeBetButtonColor: "",
    placeBetButtonTextColor: "",
    headerAccountButtonColor: "",
    headerAccountButtonTextColor: "",
    loginFooterLinkColor: "",
    loginSupportStyle: DEFAULT_LOGIN_SUPPORT_STYLE,
    loginSupportColor: "",
    loginBankingMarquee: false,
    loginBankingRocket: "",
    loginBankingBkash: "",
    loginBankingNagad: "",
    loginBankingUpay: "",
    sportsBanner: true,
    sportsBannerImage: "",
    velkiLoginBanner: "",
    velkiHomeAllImage: "",
    velkiHomeCricketImage: "",
    velkiHomeSoccerImage: "",
    velkiHomeTennisImage: "",
    sportsSlider: false,
    title: "",
    domain: "",
    alternativeDomains: [],
    favicon: "",
    logo: "",
    mobileLogo: "",
    adminLogo: "",
    agLoginLogo: "",
    loginImage: "",
    mobileLoginImage: "",
    agentListUrl: "",
    email: ["", "", ""],
    whatsapp: ["", "", "", ""],
    telegram: ["", "", ""],
    instagram: ["", "", ""],
    skype: ["", "", ""],
    maintenanceMessage: "",
    agentMessage: "",
    userMessage: "",
    adminStatus: false,
    currency: "PBU",
    theme: "sky-sky",
    liveTvMode: "sticky",
    agLoginDesign: "default",
    status: false,
    change_password_on_first_login: false,
    captchaFrontend: true,
    captchaAdmin: true,
    cricket: {
      oddsLimit: { min: 1, max: 2 },
      bet_odds_limit: { min: 1, max: 2 },
      bet_bookmaker_limit: { min: 1, max: 2 },
      bet_fancy_limit: { min: 1, max: 2 },
      bet_premium_limit: { min: 1, max: 2 },
    },
    soccer: {
      oddsLimit: { min: 1, max: 2 },
      bet_odds_limit: { min: 1, max: 2 },
      bet_bookmaker_limit: { min: 1, max: 2 },
      bet_premium_limit: { min: 1, max: 2 },
    },
    tennis: {
      oddsLimit: { min: 1, max: 2 },
      bet_odds_limit: { min: 1, max: 2 },
      bet_bookmaker_limit: { min: 1, max: 2 },
      bet_premium_limit: { min: 1, max: 2 },
    },
  });
  // console.log("formData from admin setting page ::: ", formData);
  const [SelectedColor, setSelectedColor] = useState<COLOR_OPTION_INTERFACE>(
    COLOR_OPTION.find((_) => _.value === formData.colorSchema) ||
    COLOR_OPTION[0],
  );

  const EDIT_DATA = useSelector((e: any) => e.webEdit);
  const DD = useSelector((e: any) => e.domainDetails);
  const [isHover, setIsHover] = useState(false);
  const [altDomainInput, setAltDomainInput] = useState("");
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  useEffect(() => {
    setSelectedColor(
      COLOR_OPTION.find((_) => _.value === formData.colorSchema) ||
      COLOR_OPTION[0],
    );
  }, [formData.colorSchema]);

  const dispatch = useDispatch();

  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  // const [pageData, setPageData] = useState<any>({})
  const navigate = useNavigate();
  const { id } = useParams();
  const MODE =
    window.location.pathname.includes("edit-website") && id ? "EDIT" : "ADD";
  const [activeSection, setActiveSection] = useState<WebsiteEditSectionId>(
    () => readSavedSection(id),
  );

  useEffect(() => {
    try {
      sessionStorage.setItem(
        `website-edit-section:${id || "new"}`,
        activeSection,
      );
    } catch (error) {
      return;
    }
  }, [activeSection, id]);

  const openSection = (sectionId: WebsiteEditSectionId) => {
    setActiveSection(sectionId);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sectionClass = (sectionId: WebsiteEditSectionId) =>
    `website-edit-section${activeSection === sectionId ? " is-open" : ""}`;

  // const Validator = useRef(
  //   new SimpleReactValidator({
  //     autoForceUpdate: this,
  //   }),
  // );
  const Validator = useRef(
    new SimpleReactValidator({
      validators: {
        strict_title: {
          message:
            "Title must contain a letter and use only letters, numbers, spaces, hyphens, &, or |.",
          rule: (value: string) =>
            typeof value === "string" &&
            /[A-Za-z]/.test(value) &&
            !/[^A-Za-z0-9 &|-]/.test(value),
        },
        valid_domain: {
          message:
            "Domain must use domain.com format with no protocol (http/https), trailing slash, path, port, or query.",
          rule: (value: string) => {
            if (typeof value !== "string") return false;
            if (/\s/.test(value)) return false;
            if (value.includes("://")) return false;
            return (
              value.length <= 253 &&
              /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/i.test(
                value,
              )
            );
          },
        },
      },
    }),
  );

  const firstInvalidSection = (): WebsiteEditSectionId | null => {
    const fields = Validator.current.fields || {};
    for (const section of WEBSITE_EDIT_SECTIONS) {
      const names = SECTION_REQUIRED_FIELDS[section.id] || [];
      if (names.some((name) => fields[name] === false)) {
        return section.id;
      }
    }
    return null;
  };

  const normalizeTheme = (theme?: string) => {
    if (theme === "velki") return "velki";
    return "sky-sky";
  };

  const applyWebsiteToForm = (site: any) => {
    if (!site || typeof site !== "object") return;
    setFormData((prev: any) => ({
      ...prev,
      ...site,
      theme: normalizeTheme(site.theme),
      liveTvMode: site.liveTvMode === "fixed" ? "fixed" : "sticky",
      whatsapp: [0, 1, 2, 3].map((index) =>
        Array.isArray(site.whatsapp) && site.whatsapp[index]
          ? String(site.whatsapp[index])
          : "",
      ),
      agLoginDesign: normalizeAgLoginDesign(site.agLoginDesign),
      adminHeaderSchema: site.adminHeaderSchema || "",
      adminHeaderTextColor: site.adminHeaderTextColor || "",
      adminNavSchema: site.adminNavSchema || "",
      adminNavTextColor: site.adminNavTextColor || "",
      mobileLogo: site.mobileLogo || "",
      agLoginLogo: site.agLoginLogo || "",
      mobileHeaderSchema: site.mobileHeaderSchema || "",
      mobileHeader: normalizeMobileHeaderId(site.mobileHeader),
      mobileFooter: normalizeMobileFooterId(site.mobileFooter),
      mobileFooterSchema: site.mobileFooterSchema || "",
      mobileFooterActiveColor: site.mobileFooterActiveColor || "",
      mobileEventTypeSchema: site.mobileEventTypeSchema || "",
      mobileEventTypeTextColor: site.mobileEventTypeTextColor || "",
      matchListTextColor: site.matchListTextColor || "",
      playNowButtonColor: site.playNowButtonColor || "",
      inplayCricketBanner:
        site.inplayCricketBanner !== false &&
        site.inplayCricketBanner !== "false" &&
        site.inplayCricketBanner !== 0,
      inplayCricketBannerImage: site.inplayCricketBannerImage || "",
      loginPageBgColor: site.loginPageBgColor || "",
      loginButtonColor: site.loginButtonColor || "",
      mobileLoginButtonColor: site.mobileLoginButtonColor || "",
      loginButtonTextColor: site.loginButtonTextColor || "",
      loginDownloadButtonColor: site.loginDownloadButtonColor || "",
      placeBetButtonColor: site.placeBetButtonColor || "",
      placeBetButtonTextColor: site.placeBetButtonTextColor || "",
      headerAccountButtonColor: site.headerAccountButtonColor || "",
      headerAccountButtonTextColor: site.headerAccountButtonTextColor || "",
      loginFooterLinkColor: site.loginFooterLinkColor || "",
      loginSupportStyle: normalizeLoginSupportStyle(site.loginSupportStyle),
      loginSupportColor: site.loginSupportColor || "",
      loginBankingMarquee: site.loginBankingMarquee === true,
      loginBankingRocket: site.loginBankingRocket || "",
      loginBankingBkash: site.loginBankingBkash || "",
      loginBankingNagad: site.loginBankingNagad || "",
      loginBankingUpay: site.loginBankingUpay || "",
      sportsBanner:
        site.sportsBanner !== false &&
        site.sportsBanner !== "false" &&
        site.sportsBanner !== 0,
      sportsBannerImage: site.sportsBannerImage || "",
      velkiLoginBanner: site.velkiLoginBanner || "",
      velkiHomeAllImage: site.velkiHomeAllImage || "",
      velkiHomeCricketImage: site.velkiHomeCricketImage || "",
      velkiHomeSoccerImage: site.velkiHomeSoccerImage || "",
      velkiHomeTennisImage: site.velkiHomeTennisImage || "",
      sportsSlider: site.sportsSlider === true,
      status:
        site.status === true || site.status === "true" || site.status === 1,
      adminStatus:
        site.adminStatus === true ||
        site.adminStatus === "true" ||
        site.adminStatus === 1,
      change_password_on_first_login:
        site.change_password_on_first_login === true ||
        site.change_password_on_first_login === "true" ||
        site.change_password_on_first_login === 1,
      // UI default On when field missing (existing sites); login still uses env until saved.
      captchaFrontend:
        site.captchaFrontend !== false &&
        site.captchaFrontend !== "false" &&
        site.captchaFrontend !== 0,
      captchaAdmin:
        site.captchaAdmin !== false &&
        site.captchaAdmin !== "false" &&
        site.captchaAdmin !== 0,
      alternativeDomains: Array.isArray(site.alternativeDomains)
        ? site.alternativeDomains.filter(Boolean)
        : [],
    }));
  };

  const loadWebsiteById = async (websiteId: string) => {
    const data = {
      api: ADMIN_API.SETTING.WEBSITE.GET_SITE_BY_ID,
      value: { id: websiteId },
    };
    await postApi(data)
      .then((response) => {
        const site = response?.data?.data;
        if (site) {
          applyWebsiteToForm(site);
          dispatch({ type: "EDIT_WEBSITE", payload: site });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.statusCode === 401) {
          Logout();
          navigate("/login");
        } else {
          notifyError(err?.response?.data?.message || "Failed to load website");
        }
      });
  };

  useEffect(() => {
    if (MODE === "EDIT" && id) {
      // Prefer fresh API data so theme/image edits never start from empty Redux state.
      if (EDIT_DATA && EDIT_DATA._id === id && EDIT_DATA.logo) {
        applyWebsiteToForm(EDIT_DATA);
      }
      loadWebsiteById(id);
    } else if (MODE === "EDIT" && !id) {
      navigate("/website");
    }
    return () => { };
  }, []);

  const getPageData = async () => {
    const imageFields = [
      "favicon",
      "logo",
      "adminLogo",
      "loginImage",
      "mobileLoginImage",
    ] as const;
    // console.log("imagefields::", imageFields);
    // Never overwrite existing DB images with empty strings (common when
    // saving only theme/color with incomplete form state).
    const safeImages: Record<string, string> = {};
    imageFields.forEach((field) => {
      const nextVal = (formData as any)[field];
      const prevVal = EDIT_DATA?.[field];
      safeImages[field] =
        nextVal && String(nextVal).trim()
          ? String(nextVal).trim()
          : prevVal && String(prevVal).trim()
            ? String(prevVal).trim()
            : "";
    });
    console.log("imagefields::", safeImages);
    const missingRequiredImage = (
      ["favicon", "logo", "loginImage", "mobileLoginImage"] as const
    ).find((field) => !safeImages[field]);
    if (missingRequiredImage) {
      const section = IMAGE_FIELD_SECTION[missingRequiredImage];
      if (section) setActiveSection(section);
      notifyError(`Please upload ${missingRequiredImage} before saving`);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    let data: any = {
      api:
        id && MODE === "EDIT"
          ? ADMIN_API.SETTING.WEBSITE.UPDATE
          : ADMIN_API.SETTING.WEBSITE.CREATE,
      value: {
        colorSchema: formData.colorSchema,
        headerSchema: formData.headerSchema,
        adminHeaderSchema: formData.adminHeaderSchema || "",
        adminHeaderTextColor: formData.adminHeaderTextColor || "",
        adminNavSchema: formData.adminNavSchema || "",
        adminNavTextColor: formData.adminNavTextColor || "",
        mobileHeaderSchema: formData.mobileHeaderSchema || "",
        mobileHeader: normalizeMobileHeaderId(formData.mobileHeader),
        mobileFooter: normalizeMobileFooterId(formData.mobileFooter),
        mobileFooterSchema: formData.mobileFooterSchema || "",
        mobileFooterActiveColor: formData.mobileFooterActiveColor || "",
        mobileEventTypeSchema: formData.mobileEventTypeSchema || "",
        mobileEventTypeTextColor: formData.mobileEventTypeTextColor || "",
        matchListTextColor: formData.matchListTextColor || "",
        playNowButtonColor: formData.playNowButtonColor || "",
        inplayCricketBanner: formData.inplayCricketBanner !== false,
        inplayCricketBannerImage: formData.inplayCricketBannerImage
          ? String(formData.inplayCricketBannerImage).trim()
          : "",
        loginPageBgColor: formData.loginPageBgColor || "",
        loginButtonColor: formData.loginButtonColor || "",
        mobileLoginButtonColor: formData.mobileLoginButtonColor || "",
        loginButtonTextColor: formData.loginButtonTextColor || "",
        loginDownloadButtonColor: formData.loginDownloadButtonColor || "",
        placeBetButtonColor: formData.placeBetButtonColor || "",
        placeBetButtonTextColor: formData.placeBetButtonTextColor || "",
        headerAccountButtonColor: formData.headerAccountButtonColor || "",
        headerAccountButtonTextColor: formData.headerAccountButtonTextColor || "",
        loginFooterLinkColor: formData.loginFooterLinkColor || "",
        loginSupportStyle: normalizeLoginSupportStyle(
          formData.loginSupportStyle,
        ),
        loginSupportColor: formData.loginSupportColor || "",
        loginBankingMarquee: formData.loginBankingMarquee === true,
        loginBankingRocket: formData.loginBankingRocket
          ? String(formData.loginBankingRocket).trim()
          : "",
        loginBankingBkash: formData.loginBankingBkash
          ? String(formData.loginBankingBkash).trim()
          : "",
        loginBankingNagad: formData.loginBankingNagad
          ? String(formData.loginBankingNagad).trim()
          : "",
        loginBankingUpay: formData.loginBankingUpay
          ? String(formData.loginBankingUpay).trim()
          : "",
        sportsBanner: formData.sportsBanner !== false,
        sportsBannerImage: formData.sportsBannerImage
          ? String(formData.sportsBannerImage).trim()
          : "",
        velkiLoginBanner: formData.velkiLoginBanner
          ? String(formData.velkiLoginBanner).trim()
          : "",
        velkiHomeAllImage: formData.velkiHomeAllImage
          ? String(formData.velkiHomeAllImage).trim()
          : "",
        velkiHomeCricketImage: formData.velkiHomeCricketImage
          ? String(formData.velkiHomeCricketImage).trim()
          : "",
        velkiHomeSoccerImage: formData.velkiHomeSoccerImage
          ? String(formData.velkiHomeSoccerImage).trim()
          : "",
        velkiHomeTennisImage: formData.velkiHomeTennisImage
          ? String(formData.velkiHomeTennisImage).trim()
          : "",
        sportsSlider: formData.sportsSlider === true,
        title: formData.title,
        domain: formData.domain,
        alternativeDomains: Array.isArray(formData.alternativeDomains)
          ? formData.alternativeDomains
          : [],
        favicon: safeImages.favicon,
        logo: safeImages.logo,
        mobileLogo: formData.mobileLogo
          ? String(formData.mobileLogo).trim()
          : "",
        adminLogo: safeImages.adminLogo,
        agLoginLogo: formData.agLoginLogo
          ? String(formData.agLoginLogo).trim()
          : "",
        loginImage: safeImages.loginImage,
        mobileLoginImage: safeImages.mobileLoginImage,
        agentListUrl: formData.agentListUrl,
        email: formData.email,
        whatsapp: formData.whatsapp,
        telegram: formData.telegram,
        instagram: formData.instagram,
        skype: formData.skype,
        adminStatus: formData.adminStatus,
        currency: formData.currency,
        theme: formData.theme,
        liveTvMode: formData.liveTvMode === "fixed" ? "fixed" : "sticky",
        agLoginDesign: normalizeAgLoginDesign(formData.agLoginDesign),
        status: formData.status,
        change_password_on_first_login: formData.change_password_on_first_login,
        captchaFrontend: formData.captchaFrontend !== false,
        captchaAdmin: formData.captchaAdmin !== false,
        cricket: formData.cricket,
        soccer: formData.soccer,
        tennis: formData.tennis,
        maintenanceMessage: formData.maintenanceMessage,
        agentMessage: formData.agentMessage,
        userMessage: formData.userMessage,
      },
    };
    delete data?.value?.soccer?.bet_fancy_limit;
    delete data?.value?.tennis?.bet_fancy_limit;

    if (id && MODE === "EDIT") {
      data.value.id = id;
    }
    if (formData.maintenanceMessage) {
      data.value.maintenanceMessage = formData.maintenanceMessage;
    }
    if (formData.agentMessage) {
      data.value.agentMessage = formData.agentMessage;
    }
    if (formData.userMessage) {
      data.value.userMessage = formData.userMessage;
    }
    console.log("insert images::", safeImages);
    // return;
    await postApi(data)
      .then(function (response) {
        console.log(response);
        // setPageData(response.data.data)
        notifyMessage(response.data.message);
        if (MODE === "EDIT" && id) {
          getDomainDetails(false);
          loadWebsiteById(id);
        } else {
          getDomainDetails();
        }
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        if (err.response.data.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const handleSelectChange = (e: any) => {
    console.log("page clicked", e.target.value);
    setFormData({
      ...formData,
      colorSchema:
        COLOR_OPTION.find((_) => _.value === e.target.value)?.value ||
        COLOR_OPTION[0].value,
    });
  };

  const handleInputChange = (e: any) => {
    const { name, value, type } = e.target;
    if (type === "radio") {
      const boolVal = value === "true" || value === true;
      setFormData((prev: any) => ({
        ...prev,
        [name]: boolVal,
      }));
    } else {
      setFormData((prev: any) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleCricketMinMax = (e: any, OBJECT: string = "cricket") => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      cricket: {
        ...formData.cricket,
        [OBJECT]: {
          ...formData.cricket[OBJECT],
          [name]: value,
        },
      },
    });
  };
  const handleSoccerMinMax = (e: any, OBJECT: string) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      soccer: {
        ...formData.soccer,
        [OBJECT]: {
          ...formData.soccer[OBJECT],
          [name]: value,
        },
      },
    });
  };
  const handleTennisMinMax = (e: any, OBJECT: string) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      tennis: {
        ...formData.tennis,
        [OBJECT]: {
          ...formData.tennis[OBJECT],
          [name]: value,
        },
      },
    });
  };
  const handleImageUpload = (value: string, name: string) => {
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const normalizeAltHost = (value: string) => {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/^https?:\/\//, "")
      .split("/")[0]
      .split(":")[0]
      .replace(/^www\./, "")
      .replace(/\.$/, "");
  };

  const addAlternativeDomain = () => {
    const host = normalizeAltHost(altDomainInput);
    if (!host) return;
    if (host.startsWith("ag.") || host.startsWith("msa.")) {
      notifyError(
        "Do not include ag. or msa. Use the bare hostname (example.com).",
      );
      return;
    }
    const primary = normalizeAltHost(formData.domain);
    if (host === primary) {
      notifyError(
        "Alternative domain cannot be the same as the primary domain.",
      );
      return;
    }
    const current: string[] = Array.isArray(formData.alternativeDomains)
      ? formData.alternativeDomains
      : [];
    if (current.includes(host)) {
      notifyError("That alternative domain is already added.");
      return;
    }
    setFormData((prev: any) => ({
      ...prev,
      alternativeDomains: [...(prev.alternativeDomains || []), host],
    }));
    setAltDomainInput("");
  };

  const removeAlternativeDomain = (host: string) => {
    setFormData((prev: any) => ({
      ...prev,
      alternativeDomains: (prev.alternativeDomains || []).filter(
        (item: string) => item !== host,
      ),
    }));
  };

  const handleHeaderSelect = (id: string) => {
    setFormData((prev: any) => ({
      ...prev,
      mobileHeader: normalizeMobileHeaderId(id),
    }));
  };

  const handleFooterSelect = (id: string) => {
    setFormData((prev: any) => ({
      ...prev,
      mobileFooter: normalizeMobileFooterId(id),
    }));
  };

  const handleSubmitClick = (e: any) => {
    e.preventDefault();
    if (Validator.current.allValid()) {
      getPageData();
    } else {
      Validator.current.showMessages();
      const invalidSection = firstInvalidSection();
      if (invalidSection) setActiveSection(invalidSection);
      forceUpdate();
      notifyError("Please fill in all the required fields correctly");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const getDomainDetails = async (redirect = true) => {
    let data = {
      api: ADMIN_API.SETTING.WEBSITE.GET_SITE,
      value: {
        domain: window.location.hostname,
      },
    };
    await postApi(data)
      .then(function (response) {
        console.log(response);
        dispatch({ type: "DOMAIN_DETAILS", payload: response.data.data });
        if (redirect) navigate("/website");
      })
      .catch((err) => {
        if (err.response.data.statusCode === 401) {
          Logout();
          window.open("/login");
        }
      });
  };

  const handleCancelClick = (e: any) => {
    e.preventDefault();
    navigate("/website");
  };

  const handleMultiInput = (e: any, name: string, index: number) => {
    let formDataCopy = JSON.parse(JSON.stringify(formData));
    // debugger;
    formDataCopy[name][index] = e.target.value;

    // formDataCopy[name].splice(index, 1, e.target.value);
    setFormData({ ...formData, [name]: formDataCopy[name] });
  };

  const renderAgColorField = (
    name: string,
    label: string,
    placeholder: string,
    help: string,
  ) => (
    <div
      className="mb-3"
      style={{ flex: 1, display: "flex", flexDirection: "column" }}
    >
      <label htmlFor={name}>{label}</label>
      <input
        name={name}
        id={name}
        className="form-control"
        type="text"
        placeholder={placeholder}
        value={formData[name] || ""}
        onChange={handleInputChange}
        style={{ backgroundColor: "#fff", color: "#000", width: "98%" }}
      />
      <small className="text-muted">{help}</small>
      {(formData[name] || "").trim() ? (
        <span
          style={{
            display: "block",
            width: "98%",
            height: 10,
            marginTop: 8,
            borderRadius: 2,
            border: "1px solid #d0d5dd",
            background: String(formData[name]).trim(),
          }}
        />
      ) : null}
    </div>
  );

  console.log({ formData })
  return (
    <div className="container banking website edit full-wrap">
      <div className="top_header">
        <div className="top_header_title align-items-center mt-3">
          <h5 className="font-weight-bold">
            {MODE === "EDIT" ? "Update Website" : "Add Website"}
          </h5>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm website-edit-back"
            onClick={() => navigate("/website")}
          >
            ← Back to Website List
          </button>
        </div>
      </div>

      <div className="edit_body website-edit-layout">
        <aside className="website-edit-nav" aria-label="Website sections">
          {WEBSITE_EDIT_SECTIONS.map((section, index) => (
            <button
              key={section.id}
              type="button"
              className={activeSection === section.id ? "is-active" : ""}
              onClick={() => openSection(section.id)}
            >
              <span>{index + 1}</span>
              {section.label}
            </button>
          ))}
        </aside>
        <div className="website-edit-main">
          <div className="card">
            <div className="card_body">
              <div className={`${sectionClass("basic")} card mb-15`}>
                <div className="card_header">Site Basic Information</div>
                <div className="card_body">
                  <div className="row">
                    <div className="card_body_h_item">
                      <label htmlFor="title">
                        Title: <span style={{ color: "#dc3545" }}>*</span>
                      </label>
                      <input
                        onChange={(e) => handleInputChange(e)}
                        className="form-control"
                        name="title"
                        type="text"
                        value={formData.title}
                        id="title"
                        onBlur={() => {
                          Validator.current.showMessageFor("title");
                          forceUpdate();
                        }}
                      ></input>
                      <span className="text-danger">
                        {Validator.current.message(
                          "title",
                          formData.title,
                          "required|strict_title",
                        )}
                      </span>
                    </div>

                    <div className="mb-3 card_body_h_item">
                      <label htmlFor="domain">
                        Domain: <span style={{ color: "#dc3545" }}>*</span>
                      </label>
                      <input
                        onChange={(e) => handleInputChange(e)}
                        className="form-control"
                        name="domain"
                        type="text"
                        value={formData.domain}
                        id="domain"
                        placeholder="domain.com"
                        onBlur={() => {
                          Validator.current.showMessageFor("domain");
                          forceUpdate();
                        }}
                      />
                      <span className="text-danger">
                        {Validator.current.message(
                          "domain",
                          formData.domain,
                          "required|valid_domain",
                        )}
                      </span>
                    </div>

                    <div className="mb-3 card_body_h_item_wrap">
                      <div className="card_body_h_item">
                        <label htmlFor="alternativeDomainInput">
                          Alternative domains:
                        </label>
                        <div className="alt_domain_input">
                          <input
                            className="form-control"
                            id="alternativeDomainInput"
                            type="text"
                            placeholder="domain.com"
                            value={altDomainInput}
                            onChange={(e) => setAltDomainInput(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                addAlternativeDomain();
                              }
                            }}
                          />
                          <button
                            type="button"
                            className="btn_black"
                            onClick={addAlternativeDomain}
                          >
                            Add
                          </button>
                        </div>
                        <small className="alt_domain_hint">
                          Same website if the primary domain is blocked. After
                          save, point DNS for each extra host and run
                          add-new-website.sh on the server (nginx + SSL).
                        </small>
                        {(formData.alternativeDomains || []).length > 0 && (
                          <div className="alt_domain_tags">
                            {(formData.alternativeDomains || []).map(
                              (host: string) => (
                                <span key={host} className="alt_domain_tag">
                                  {host}
                                  <button
                                    type="button"
                                    onClick={() => removeAlternativeDomain(host)}
                                    aria-label={`Remove ${host}`}
                                  >
                                    ×
                                  </button>
                                </span>
                              ),
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 card_body_h_item">
                      <label htmlFor="theme">Theme:</label>
                      <select
                        className="form-control"
                        value={normalizeTheme(formData.theme)}
                        id="theme"
                        name="theme"
                        onChange={(e) => handleInputChange(e)}
                      >
                        {THEME_OPTION.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {normalizeTheme(formData.theme) === "sky-sky" && (
                      <div className="mb-3 card_body_h_item">
                        <label htmlFor="liveTvMode">Live TV:</label>
                        <select
                          className="form-control"
                          value={formData.liveTvMode === "fixed" ? "fixed" : "sticky"}
                          id="liveTvMode"
                          name="liveTvMode"
                          onChange={(e) => handleInputChange(e)}
                        >
                          <option value="sticky">Sticky TV</option>
                          <option value="fixed">Fixed TV</option>
                        </select>
                        <small className="alt_domain_hint">
                          Sticky TV is selected for every website by default.
                          Fixed TV shows only on a website where this is set to
                          Fixed TV.
                        </small>
                      </div>
                    )}

                    <div className="mb-3 card_body_h_item">
                      <label htmlFor="agLoginDesign">AG login page:</label>
                      <select
                        className="form-control"
                        value={normalizeAgLoginDesign(formData.agLoginDesign)}
                        id="agLoginDesign"
                        name="agLoginDesign"
                        onChange={(e) => handleInputChange(e)}
                      >
                        {AG_LOGIN_DESIGN_OPTIONS.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      <small className="alt_domain_hint">
                        Default keeps the current agent login. Velki AG login is
                        a separate page for this domain only.
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("header")} card mb-15`}>
                <div className="card_header">Header</div>
                <div className="card_body">
                  <div className="row">
                    <div
                      className="mb-3 ml-2 mr-3"
                      style={{
                        flex: 0.6,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="color_schema">Color Schema:</label>
                      <select
                        name="color_schema"
                        id="color_schema"
                        className="form-control"
                        value={SelectedColor.value}
                        style={{
                          backgroundColor: SelectedColor.backgroundColor,
                          color: SelectedColor.color,
                          width: "98%",
                        }}
                        onChange={(e) => handleSelectChange(e)}
                      >
                        {COLOR_OPTION.map((item: COLOR_OPTION_INTERFACE) => {
                          return (
                            <option
                              key={item.value}
                              style={{
                                backgroundColor: item.backgroundColor,
                                color: item.color,
                              }}
                              value={item.value}
                            >
                              {item.label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 0.6,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="headerSchema">
                        Header Schema: <span style={{ color: "#dc3545" }}>*</span>
                      </label>
                      <input
                        name="headerSchema"
                        id="headerSchema"
                        className="form-control"
                        type="text"
                        placeholder="#4b930c or linear-gradient(180deg, #383838 0%, #010101 100%)"
                        value={formData.headerSchema}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <span className="text-danger">
                        {Validator.current.message(
                          "headerSchema",
                          formData.headerSchema,
                          "required",
                        )}
                      </span>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 0.6,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="headerAccountButtonColor">
                        Bets, Balance & Exposure Color:
                      </label>
                      <input
                        name="headerAccountButtonColor"
                        id="headerAccountButtonColor"
                        className="form-control"
                        type="text"
                        placeholder="#333333 or linear-gradient(-180deg, #2f424d, #141e21)"
                        value={formData.headerAccountButtonColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Background for Bets, Balance, Exposure and the settings button.
                        Hex or CSS gradient. Leave blank to keep the original gray.
                      </small>
                      {(formData.headerAccountButtonColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(formData.headerAccountButtonColor).trim(),
                          }}
                        />
                      ) : null}
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 0.6,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="headerAccountButtonTextColor">
                        Bets, Balance & Exposure Text Color:
                      </label>
                      <input
                        name="headerAccountButtonTextColor"
                        id="headerAccountButtonTextColor"
                        className="form-control"
                        type="text"
                        placeholder="#ffffff"
                        value={formData.headerAccountButtonTextColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Text and icons on those buttons, including the settings gear.
                        Leave blank to keep the theme color.
                      </small>
                      {(formData.headerAccountButtonTextColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(formData.headerAccountButtonTextColor).trim(),
                          }}
                        />
                      ) : null}
                    </div>

                    <div className="card_body_f_item">
                      <ImageUpload
                        label={
                          <span>
                            Favicon Image{" "}
                            <span style={{ color: "#dc3545" }}>*</span>
                          </span>
                        }
                        filename={formData.favicon}
                        name="favicon"
                        setFileName={handleImageUpload}
                        validateImage={true}
                        error={Validator.current.message(
                          "favicon",
                          formData.favicon,
                          "required",
                        )}
                        domain={formData.domain}
                      />

                      <ImageUpload
                        label={
                          <span>
                            Logo Image <span style={{ color: "#dc3545" }}>*</span>
                          </span>
                        }
                        filename={formData.logo}
                        name="logo"
                        setFileName={handleImageUpload}
                        validateImage={true}
                        error={Validator.current.message(
                          "logo",
                          formData.logo,
                          "required",
                        )}
                        domain={formData.domain}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("login-images")} card mb-15`}>
                <div className="card_header">Login Images</div>
                <div className="card_body">
                  <div className="row">
                    <div className="card_body_f_item">
                      <ImageUpload
                        label={
                          <span>
                            Login Image{" "}
                            <span style={{ color: "#dc3545" }}>*</span>
                          </span>
                        }
                        filename={formData.loginImage}
                        name="loginImage"
                        setFileName={handleImageUpload}
                        validateImage={true}
                        error={Validator.current.message(
                          "loginImage",
                          formData.loginImage,
                          "required",
                        )}
                        domain={formData.domain}
                      />

                      <ImageUpload
                        label={
                          <span>
                            Mobile Login Image{" "}
                            <span style={{ color: "#dc3545" }}>*</span>
                          </span>
                        }
                        filename={formData.mobileLoginImage}
                        name="mobileLoginImage"
                        setFileName={handleImageUpload}
                        validateImage={true}
                        error={Validator.current.message(
                          "mobileLoginImage",
                          formData.mobileLoginImage,
                          "required",
                        )}
                        domain={formData.domain}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("sports")} card mb-15`}>
                <div className="card_header">Sports Banner</div>
                <div className="card_body">
                  <div className="row">
                    <div className="mb-3 col-12">
                      <label style={{ display: "block" }}>Sports Banner:</label>
                      <small className="text-muted d-block mb-2">
                        Shown on the sports pages opened from the footer. On by
                        default with the current banner. Turn off to hide it for
                        this website, or upload a new image. Clear the image to
                        use the default banner again.
                      </small>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "8px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              sportsBanner: true,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.sportsBanner !== false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.sportsBanner !== false ? 600 : 500,
                            color: "#212529",
                          }}
                        >
                          On
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              sportsBanner: false,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.sportsBanner === false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.sportsBanner === false ? 600 : 500,
                            color: "#212529",
                          }}
                        >
                          Off
                        </button>
                      </div>
                      <ImageUpload
                        label="Sports Banner Image (optional)"
                        filename={formData.sportsBannerImage}
                        name="sportsBannerImage"
                        setFileName={handleImageUpload}
                        allowClear={true}
                        domain={formData.domain}
                        topClass="mb-3"
                      />
                      <label
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          marginTop: "4px",
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                      >
                        <input
                          type="checkbox"
                          name="sportsSlider"
                          checked={formData.sportsSlider === true}
                          onChange={(e) =>
                            setFormData((prev: any) => ({
                              ...prev,
                              sportsSlider: e.target.checked,
                            }))
                          }
                        />
                        Show home slider on sports pages
                      </label>
                      <small className="text-muted d-block">
                        Off by default, so this website keeps the current sports
                        page. Check it to show the same banner slider as the home
                        page on the sports pages opened from the mobile footer.
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("velki")} card mb-15`}>
                <div className="card_header">Velki Theme Images (optional)</div>
                <div className="card_body">
                  <div className="row">
                    <div className="mb-3 col-12">
                      <small className="text-muted d-block mb-2">
                        Used only when this website theme is Velki. Leave blank
                        to keep the current built-in images. Clear an image to
                        go back to the built-in one.
                      </small>
                      <div className="card_body_f_item">
                        <ImageUpload
                          label="Login banner (above the login form)"
                          filename={formData.velkiLoginBanner}
                          name="velkiLoginBanner"
                          setFileName={handleImageUpload}
                          allowClear={true}
                          domain={formData.domain}
                        />
                        <ImageUpload
                          label="Home card — All"
                          filename={formData.velkiHomeAllImage}
                          name="velkiHomeAllImage"
                          setFileName={handleImageUpload}
                          allowClear={true}
                          domain={formData.domain}
                        />
                        <ImageUpload
                          label="Home card — Cricket"
                          filename={formData.velkiHomeCricketImage}
                          name="velkiHomeCricketImage"
                          setFileName={handleImageUpload}
                          allowClear={true}
                          domain={formData.domain}
                        />
                        <ImageUpload
                          label="Home card — Soccer"
                          filename={formData.velkiHomeSoccerImage}
                          name="velkiHomeSoccerImage"
                          setFileName={handleImageUpload}
                          allowClear={true}
                          domain={formData.domain}
                        />
                        <ImageUpload
                          label="Home card — Tennis"
                          filename={formData.velkiHomeTennisImage}
                          name="velkiHomeTennisImage"
                          setFileName={handleImageUpload}
                          allowClear={true}
                          domain={formData.domain}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("basic")} card mb-15`}>
                <div className="card_header">Status & Security</div>
                <div className="card_body">
                  <div className="row">
                    <div className="mb-3 col-2 card_body_item ">
                      <label htmlFor="currency">
                        Currency: <span style={{ color: "#dc3545" }}>*</span>
                      </label>
                      <input
                        className="form-control"
                        onChange={(e) => handleInputChange(e)}
                        name="currency"
                        type="text"
                        value={formData.currency}
                        id="currency"
                      />
                      <span className="text-danger">
                        {Validator.current.message(
                          "currency",
                          formData.currency,
                          "required",
                        )}
                      </span>
                    </div>

                    <div className="mb-3 col-4 card_body_item">
                      <label htmlFor="agentListUrl">Agent List URL:</label>
                      <input
                        className="form-control"
                        onChange={(e) => handleInputChange(e)}
                        value={formData.agentListUrl}
                        name="agentListUrl"
                        type="text"
                        id="agent_list_url"
                      />
                    </div>

                    <div className="mb-3 col-3 card_body_item">
                      <label style={{ display: "block" }}>Status:</label>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              status: true,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.status === true
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: formData.status === true ? 600 : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.status === true
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.status === true && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          On
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              status: false,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.status === false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: formData.status === false ? 600 : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.status === false
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.status === false && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          Off
                        </button>
                      </div>
                    </div>

                    <div className="mb-3 col-3 card_body_item">
                      <label style={{ display: "block" }}>Admin Status:</label>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              adminStatus: true,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.adminStatus === true
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: formData.adminStatus === true ? 600 : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.adminStatus === true
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.adminStatus === true && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          On
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              adminStatus: false,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.adminStatus === false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.adminStatus === false ? 600 : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.adminStatus === false
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.adminStatus === false && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          Off
                        </button>
                      </div>
                    </div>

                    <div className="mb-3 col-3 card_body_item">
                      <label style={{ display: "block" }}>
                        Force to change password on first login:
                      </label>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              change_password_on_first_login: true,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.change_password_on_first_login === true
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.change_password_on_first_login === true
                                ? 600
                                : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.change_password_on_first_login === true
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.change_password_on_first_login === true && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          On
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              change_password_on_first_login: false,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.change_password_on_first_login === false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.change_password_on_first_login === false
                                ? 600
                                : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.change_password_on_first_login === false
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.change_password_on_first_login ===
                              false && (
                                <span
                                  style={{
                                    width: "8px",
                                    height: "8px",
                                    borderRadius: "50%",
                                    backgroundColor:
                                      getTheme(DD?.colorSchema)?.backgroundColor ||
                                      "#0d6efd",
                                    display: "block",
                                  }}
                                />
                              )}
                          </span>
                          Off
                        </button>
                      </div>
                    </div>

                    <div className="mb-3 col-3 card_body_item">
                      <label style={{ display: "block" }}>
                        Frontend Captcha (sky-sky):
                      </label>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              captchaFrontend: true,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.captchaFrontend === true
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.captchaFrontend === true ? 600 : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.captchaFrontend === true
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.captchaFrontend === true && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          On
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              captchaFrontend: false,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.captchaFrontend === false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.captchaFrontend === false ? 600 : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.captchaFrontend === false
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.captchaFrontend === false && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          Off
                        </button>
                      </div>
                    </div>

                    <div className="mb-3 col-3 card_body_item">
                      <label
                        style={{
                          display: "block",
                        }}
                      >
                        Admin Captcha (sky-admin):
                      </label>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              captchaAdmin: true,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.captchaAdmin === true
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.captchaAdmin === true ? 600 : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.captchaAdmin === true
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.captchaAdmin === true && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          On
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              captchaAdmin: false,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.captchaAdmin === false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.captchaAdmin === false ? 600 : 500,
                            color: "#212529",
                            userSelect: "none",
                            transition: "border-color 0.15s ease",
                          }}
                        >
                          <span
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              border:
                                formData.captchaAdmin === false
                                  ? `2px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "2px solid #adb5bd",
                              backgroundColor: "transparent",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxSizing: "border-box",
                              flexShrink: 0,
                            }}
                          >
                            {formData.captchaAdmin === false && (
                              <span
                                style={{
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    getTheme(DD?.colorSchema)?.backgroundColor ||
                                    "#0d6efd",
                                  display: "block",
                                }}
                              />
                            )}
                          </span>
                          Off
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("ag")} card mb-15`}>
                <div className="card_header">AG Panel</div>
                <div className="card_body">
                  <div className="row">
                    <div className="mb-3 col-12">
                      <small className="text-muted">
                        Leave blank to keep the current agent panel look. Header
                        and top nav are separate, so you can color one without
                        changing the other.
                      </small>
                    </div>
                    {renderAgColorField(
                      "adminHeaderSchema",
                      "Header Color:",
                      "#474747 or linear-gradient(180deg, #474747 0%, #070707 100%)",
                      "Top bar behind the logo and account. Leave blank for the current dark header.",
                    )}
                    {renderAgColorField(
                      "adminHeaderTextColor",
                      "Header Text Color:",
                      "#ffffff",
                      "Account name and balance text. Leave blank to auto-pick from header color, or keep white if header color is also blank.",
                    )}
                    {renderAgColorField(
                      "adminNavSchema",
                      "Top Nav Color:",
                      "#4b930c or linear-gradient(180deg, #383838 0%, #010101 100%)",
                      "Menu bar under the header. Leave blank to keep the current color schema menu.",
                    )}
                    {renderAgColorField(
                      "adminNavTextColor",
                      "Top Nav Text Color:",
                      "#ffffff",
                      "Menu, logout and timezone text. Leave blank to auto-pick from nav color, or keep the current menu text if nav color is also blank.",
                    )}
                    <div className="card_body_f_item">
                      <ImageUpload
                        label={
                          <span>
                            Admin Logo Image:{" "}
                            {/* <span style={{ color: "#dc3545" }}>*</span> */}
                          </span>
                        }
                        filename={formData?.adminLogo}
                        name="adminLogo"
                        setFileName={handleImageUpload}
                        // error={Validator.current.message(
                        //   "adminLogo",
                        //   formData.adminLogo,
                        //   "required",
                        // )}
                        domain={formData.domain}
                      />
                      <ImageUpload
                        label={
                          <span>
                            AG Login Logo:{" "}
                            <small className="text-muted d-block">
                              Leave blank to keep the current AG login image.
                            </small>
                          </span>
                        }
                        filename={formData?.agLoginLogo}
                        name="agLoginLogo"
                        setFileName={handleImageUpload}
                        allowClear={true}
                        domain={formData.domain}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("mobile-header")} card mb-15`}>
                <div className="card_header">Mobile Header</div>
                <div className="card_body">
                  <div className="row">
                    <div className="mb-3 col-12">
                      <small className="text-muted">
                        Leave blank to use the same logo and header as webview.
                      </small>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 0.6,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="mobileHeaderSchema">
                        Mobile Header Schema:
                      </label>
                      <input
                        name="mobileHeaderSchema"
                        id="mobileHeaderSchema"
                        className="form-control"
                        type="text"
                        placeholder="#4b930c or linear-gradient(180deg, #383838 0%, #010101 100%)"
                        value={formData.mobileHeaderSchema || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                    </div>
                    <div className="card_body_f_item">
                      <ImageUpload
                        label="Mobile Logo Image"
                        filename={formData.mobileLogo}
                        name="mobileLogo"
                        setFileName={handleImageUpload}
                        allowClear={true}
                        domain={formData.domain}
                      />
                    </div>
                    {normalizeTheme(formData.theme) === "sky-sky" && (
                      <div className="mb-3 col-12 mobile-footer-picker">
                        <label>Mobile Header:</label>
                        <small className="text-muted d-block mb-2">
                          Select a mobile header for this website. Default header
                          is used if none is selected.
                        </small>
                        <div
                          className="mobile-footer-picker-grid"
                          style={{ gridTemplateColumns: "1fr 1fr" }}
                        >
                          {MOBILE_HEADER_OPTIONS.map((option) => {
                            const selected =
                              normalizeMobileHeaderId(formData.mobileHeader) ===
                              option.id;
                            return (
                              <label
                                key={option.id}
                                className={`mobile-footer-option${selected ? " is-selected" : ""}`}
                              >
                                <input
                                  type="checkbox"
                                  name="mobileHeader"
                                  checked={selected}
                                  onChange={() => {
                                    const current = normalizeMobileHeaderId(
                                      formData.mobileHeader,
                                    );
                                    if (current === option.id) {
                                      handleHeaderSelect(DEFAULT_MOBILE_HEADER);
                                    } else {
                                      handleHeaderSelect(option.id);
                                    }
                                  }}
                                />
                                <span className="mobile-footer-option-meta">
                                  <strong>{option.label}</strong>
                                  <em>{option.hint}</em>
                                </span>
                              </label>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("mobile-footer")} card mb-15`}>
                <div className="card_header">Mobile Footer</div>
                <div className="card_body">
                  <div className="row">
                    <div className="mb-3 col-12 mobile-footer-picker">
                      <label>Mobile Footer:</label>
                      <small className="text-muted d-block mb-2">
                        Select one footer for this website. Games bar is selected
                        by default.
                      </small>
                      <div className="mobile-footer-picker-grid">
                        {MOBILE_FOOTER_OPTIONS.map((option) => {
                          const selected =
                            normalizeMobileFooterId(formData.mobileFooter) ===
                            option.id;
                          return (
                            <label
                              key={option.id}
                              className={`mobile-footer-option${selected ? " is-selected" : ""}`}
                            >
                              <input
                                type="checkbox"
                                name="mobileFooter"
                                checked={selected}
                                onChange={() => {
                                  const current = normalizeMobileFooterId(
                                    formData.mobileFooter,
                                  );
                                  if (current === option.id) {
                                    handleFooterSelect(DEFAULT_MOBILE_FOOTER);
                                  } else {
                                    handleFooterSelect(option.id);
                                  }
                                }}
                              />
                              <span className="mobile-footer-option-preview">
                                <img src={option.preview} alt={option.label} />
                              </span>
                              <span className="mobile-footer-option-meta">
                                <strong>{option.label}</strong>
                                <em>{option.hint}</em>
                              </span>
                            </label>
                          );
                        })}
                      </div>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="mobileFooterSchema">
                        Mobile Footer Color:
                      </label>
                      <input
                        name="mobileFooterSchema"
                        id="mobileFooterSchema"
                        className="form-control"
                        type="text"
                        placeholder="#1a2c38 or linear-gradient(-180deg, #243a48 20%, #172732 91%)"
                        value={formData.mobileFooterSchema || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Hex or CSS gradient for the selected footer background.
                        Leave blank for the default dark bar.
                      </small>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="mobileFooterActiveColor">
                        Mobile Footer Active Color:
                      </label>
                      <input
                        name="mobileFooterActiveColor"
                        id="mobileFooterActiveColor"
                        className="form-control"
                        type="text"
                        placeholder="#32617f or rgba(255,255,255,0.16)"
                        value={formData.mobileFooterActiveColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Color for the selected/active tab on every footer style.
                        Hex or CSS gradient. Leave blank for default.
                      </small>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="mobileEventTypeSchema">
                        In-Play Event Type Color:
                      </label>
                      <input
                        name="mobileEventTypeSchema"
                        id="mobileEventTypeSchema"
                        className="form-control"
                        type="text"
                        placeholder="#243a48 or linear-gradient(-180deg, #2e4b5e, #243a48 82%)"
                        value={formData.mobileEventTypeSchema || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Hex or CSS gradient for Cricket / Soccer / Tennis titles
                        on mobile In-Play. Leave blank for default.
                      </small>
                      {(formData.mobileEventTypeSchema || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(
                              formData.mobileEventTypeSchema,
                            ).trim(),
                          }}
                        />
                      ) : null}
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="mobileEventTypeTextColor">
                        In-Play Event Type Text Color:
                      </label>
                      <input
                        name="mobileEventTypeTextColor"
                        id="mobileEventTypeTextColor"
                        className="form-control"
                        type="text"
                        placeholder="#fff"
                        value={formData.mobileEventTypeTextColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Text color for Cricket / Soccer / Tennis titles on mobile
                        In-Play. Leave blank to keep white.
                      </small>
                      {(formData.mobileEventTypeTextColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(
                              formData.mobileEventTypeTextColor,
                            ).trim(),
                          }}
                        />
                      ) : null}
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="matchListTextColor">
                        Match List Text Color:
                      </label>
                      <input
                        name="matchListTextColor"
                        id="matchListTextColor"
                        className="form-control"
                        type="text"
                        placeholder="#2789ce"
                        value={formData.matchListTextColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Match name color on In-Play and Sports lists. Leave blank
                        for the current blue.
                      </small>
                      {(formData.matchListTextColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            marginTop: 8,
                            fontSize: 13,
                            color: String(formData.matchListTextColor).trim(),
                          }}
                        >
                          Match name
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("buttons")} card mb-15`}>
                <div className="card_header">Buttons & Banners</div>
                <div className="card_body">
                  <div className="row">
                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="playNowButtonColor">
                        Play Now Button Background:
                      </label>
                      <input
                        name="playNowButtonColor"
                        id="playNowButtonColor"
                        className="form-control"
                        type="text"
                        placeholder="#ffb80c or linear-gradient(-180deg, #ffb80c, #e6a000)"
                        value={formData.playNowButtonColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        One color for the home Play Now button, its arrow, and
                        the entrance title line. Leave blank to keep the current
                        theme color.
                      </small>
                      {(formData.playNowButtonColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(formData.playNowButtonColor).trim(),
                          }}
                        />
                      ) : null}
                    </div>
                    <div className="mb-3 col-12">
                      <label style={{ display: "block" }}>
                        In-Play Cricket Banner:
                      </label>
                      <small className="text-muted d-block mb-2">
                        Shown under cricket on the In-Play page. On by default
                        with the current image. Turn off to hide it, or upload a
                        new image. Clear the image to use the default again.
                      </small>
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "8px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              inplayCricketBanner: true,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.inplayCricketBanner !== false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.inplayCricketBanner !== false ? 600 : 500,
                            color: "#212529",
                          }}
                        >
                          On
                        </button>
                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev: any) => ({
                              ...prev,
                              inplayCricketBanner: false,
                            }))
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "7px",
                            background: "transparent",
                            border:
                              formData.inplayCricketBanner === false
                                ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                : "1px solid #ced4da",
                            borderRadius: "4px",
                            padding: "4px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight:
                              formData.inplayCricketBanner === false ? 600 : 500,
                            color: "#212529",
                          }}
                        >
                          Off
                        </button>
                      </div>
                      <ImageUpload
                        label="In-Play Cricket Banner Image (optional)"
                        filename={formData.inplayCricketBannerImage}
                        name="inplayCricketBannerImage"
                        setFileName={handleImageUpload}
                        allowClear={true}
                        domain={formData.domain}
                        topClass="mb-3"
                      />
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="placeBetButtonColor">
                        Place Bet Button Color:
                      </label>
                      <input
                        name="placeBetButtonColor"
                        id="placeBetButtonColor"
                        className="form-control"
                        type="text"
                        placeholder="#e31c23 or linear-gradient(-180deg, #464646 15%, #121212)"
                        value={formData.placeBetButtonColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Mobile sports Place Bet button background. Hex or CSS
                        gradient. Leave blank for the current dark button.
                      </small>
                      {(formData.placeBetButtonColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(
                              formData.placeBetButtonColor,
                            ).trim(),
                          }}
                        />
                      ) : null}
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="placeBetButtonTextColor">
                        Place Bet Button Text Color:
                      </label>
                      <input
                        name="placeBetButtonTextColor"
                        id="placeBetButtonTextColor"
                        className="form-control"
                        type="text"
                        placeholder="#ffffff"
                        value={formData.placeBetButtonTextColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Color of the words Place Bet on mobile sports. Leave blank
                        for the current theme color.
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${sectionClass("login")} card mb-15`}>
                <div className="card_header">Login Page</div>
                <div className="card_body">
                  <div className="row">
                    <div className="mb-3 col-12" style={{ marginTop: 8 }}>
                      <strong>Login Page (optional)</strong>
                      <small className="text-muted d-block">
                        Leave blank to keep the current login look. Fill these to
                        match another site without changing other websites.
                      </small>
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="loginPageBgColor">
                        Login Background Color:
                      </label>
                      <input
                        name="loginPageBgColor"
                        id="loginPageBgColor"
                        className="form-control"
                        type="text"
                        placeholder="#f00201 or linear-gradient(180deg, #8B0000 0%, #4a0a0a 100%)"
                        value={formData.loginPageBgColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Page background under the form. Hex or CSS gradient. Leave
                        blank for the theme default.
                      </small>
                      {(formData.loginPageBgColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(formData.loginPageBgColor).trim(),
                          }}
                        />
                      ) : null}
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="loginButtonColor">
                        Login Button Color:
                      </label>
                      <input
                        name="loginButtonColor"
                        id="loginButtonColor"
                        className="form-control"
                        type="text"
                        placeholder="#e31c23 or linear-gradient(180deg, #e31c23 0%, #b01018 100%)"
                        value={formData.loginButtonColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Login button background. Hex or CSS gradient. Leave blank
                        for the current dark header gradient.
                      </small>
                      {(formData.loginButtonColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(formData.loginButtonColor).trim(),
                          }}
                        />
                      ) : null}
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="mobileLoginButtonColor">
                        Mobile Login Button Color:
                      </label>
                      <input
                        name="mobileLoginButtonColor"
                        id="mobileLoginButtonColor"
                        className="form-control"
                        type="text"
                        placeholder="#e83523 or linear-gradient(180deg, #f72424 0%, #bb1c00 100%)"
                        value={formData.mobileLoginButtonColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Header Login button on mobile only. Leave blank to keep
                        the current red gradient. Other websites stay unchanged.
                      </small>
                      {(formData.mobileLoginButtonColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(formData.mobileLoginButtonColor).trim(),
                          }}
                        />
                      ) : null}
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="loginButtonTextColor">
                        Login Button Text Color:
                      </label>
                      <input
                        name="loginButtonTextColor"
                        id="loginButtonTextColor"
                        className="form-control"
                        type="text"
                        placeholder="#ffffff"
                        value={formData.loginButtonTextColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Color of the word Login. Use #fff for a light label on a
                        red button. Leave blank for theme default.
                      </small>
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="loginDownloadButtonColor">
                        Download Button Background Color:
                      </label>
                      <input
                        name="loginDownloadButtonColor"
                        id="loginDownloadButtonColor"
                        className="form-control"
                        type="text"
                        placeholder="#000000 or rgba(0, 0, 0, 0.6)"
                        value={formData.loginDownloadButtonColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Download App button background. Hex, rgba, or CSS
                        gradient. Leave blank for black.
                      </small>
                      {(formData.loginDownloadButtonColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(
                              formData.loginDownloadButtonColor,
                            ).trim(),
                          }}
                        />
                      ) : null}
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="loginFooterLinkColor">
                        Login Footer Link Color:
                      </label>
                      <input
                        name="loginFooterLinkColor"
                        id="loginFooterLinkColor"
                        className="form-control"
                        type="text"
                        placeholder="#ffffff"
                        value={formData.loginFooterLinkColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Privacy Policy, Terms, KYC and other footer URL text.
                        Leave blank for theme default.
                      </small>
                    </div>

                    <div className="mb-3 col-12 mobile-footer-picker">
                      <label>After Footer Links Section:</label>
                      <small className="text-muted d-block mb-2">
                        Style of the support / social block under the policy
                        links.
                      </small>
                      <div className="mobile-footer-picker-grid">
                        {LOGIN_SUPPORT_STYLE_OPTIONS.map((option) => {
                          const selected =
                            normalizeLoginSupportStyle(
                              formData.loginSupportStyle,
                            ) === option.id;
                          return (
                            <label
                              key={option.id}
                              className={`mobile-footer-option${selected ? " is-selected" : ""}`}
                            >
                              <input
                                type="checkbox"
                                name="loginSupportStyle"
                                checked={selected}
                                onChange={() =>
                                  setFormData((prev: any) => ({
                                    ...prev,
                                    loginSupportStyle: option.id,
                                  }))
                                }
                              />
                              <span className="mobile-footer-option-meta">
                                <strong>{option.label}</strong>
                                <em>{option.hint}</em>
                              </span>
                            </label>
                          );
                        })}
                      </div>
                    </div>

                    <div
                      className="mb-3"
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label htmlFor="loginSupportColor">
                        Support Section Color:
                      </label>
                      <input
                        name="loginSupportColor"
                        id="loginSupportColor"
                        className="form-control"
                        type="text"
                        placeholder="#ffffff or rgba(255,255,255,0.4)"
                        value={formData.loginSupportColor || ""}
                        onChange={handleInputChange}
                        style={{
                          backgroundColor: "#fff",
                          color: "#000",
                          width: "98%",
                        }}
                      />
                      <small className="text-muted">
                        Default bars: button background. Icon with lines: divider
                        and icon border. Sky support: the full-width bar. Leave
                        blank for the style default.
                      </small>
                      {(formData.loginSupportColor || "").trim() ? (
                        <span
                          style={{
                            display: "block",
                            width: "98%",
                            height: 10,
                            marginTop: 8,
                            borderRadius: 2,
                            border: "1px solid #d0d5dd",
                            background: String(formData.loginSupportColor).trim(),
                          }}
                        />
                      ) : null}
                    </div>

                    {normalizeTheme(formData.theme) === "sky-sky" && (
                      <div className="mb-3 col-12">
                        <label style={{ display: "block" }}>
                          Login banking marquee:
                        </label>
                        <small className="text-muted d-block mb-2">
                          Off by default, so this website keeps the current login
                          page. Turn on to show the mobile banking logos under the
                          login form. Upload a logo to replace that item, or
                          clear it to use the built-in image again.
                        </small>
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "8px",
                          }}
                        >
                          <button
                            type="button"
                            onClick={() =>
                              setFormData((prev: any) => ({
                                ...prev,
                                loginBankingMarquee: true,
                              }))
                            }
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "7px",
                              background: "transparent",
                              border:
                                formData.loginBankingMarquee === true
                                  ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "1px solid #ced4da",
                              borderRadius: "4px",
                              padding: "4px 12px",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                formData.loginBankingMarquee === true ? 600 : 500,
                              color: "#212529",
                            }}
                          >
                            On
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              setFormData((prev: any) => ({
                                ...prev,
                                loginBankingMarquee: false,
                              }))
                            }
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "7px",
                              background: "transparent",
                              border:
                                formData.loginBankingMarquee !== true
                                  ? `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor || "#0d6efd"}`
                                  : "1px solid #ced4da",
                              borderRadius: "4px",
                              padding: "4px 12px",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                formData.loginBankingMarquee !== true ? 600 : 500,
                              color: "#212529",
                            }}
                          >
                            Off
                          </button>
                        </div>
                        <div className="card_body_f_item">
                          <ImageUpload
                            label="Rocket"
                            filename={formData.loginBankingRocket}
                            name="loginBankingRocket"
                            setFileName={handleImageUpload}
                            allowClear={true}
                            domain={formData.domain}
                          />
                          <ImageUpload
                            label="bKash"
                            filename={formData.loginBankingBkash}
                            name="loginBankingBkash"
                            setFileName={handleImageUpload}
                            allowClear={true}
                            domain={formData.domain}
                          />
                          <ImageUpload
                            label="Nagad"
                            filename={formData.loginBankingNagad}
                            name="loginBankingNagad"
                            setFileName={handleImageUpload}
                            allowClear={true}
                            domain={formData.domain}
                          />
                          <ImageUpload
                            label="Upay"
                            filename={formData.loginBankingUpay}
                            name="loginBankingUpay"
                            setFileName={handleImageUpload}
                            allowClear={true}
                            domain={formData.domain}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* 
            <div className="card mb-15">
              <div className="card_header">Social Media For Website</div>
              <div className="card_body social-media">
                <div className="row mb_15 mb_15">
                  <div className="col-2 d_flex d_flex_align_center">
                    <label className="d_flex d_flex_align_center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="#d71b1b"
                          d="M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                        />
                      </svg>
                      Email{" "}
                    </label>
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="email-0"
                      onChange={(e) => handleMultiInput(e, "email", 0)}
                      id="email-0"
                      placeholder="Email..."
                      value={formData.email[0] ? formData.email[0] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="email-1"
                      onChange={(e) => handleMultiInput(e, "email", 1)}
                      id="email-1"
                      placeholder="Email..."
                      value={formData.email[1] ? formData.email[1] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="email-2"
                      onChange={(e) => handleMultiInput(e, "email", 2)}
                      id="email-2"
                      placeholder="Email..."
                      value={formData.email[2] ? formData.email[2] : ""}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row mb_15">
                  <div className="col-2 d_flex d_flex_align_center">
                    <label className="d_flex d_flex_align_center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="#1bd741"
                          d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                        />
                      </svg>
                      WhatsApp{" "}
                    </label>
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="whatsapp-0"
                      onChange={(e) => handleMultiInput(e, "whatsapp", 0)}
                      id="whatsapp-0"
                      placeholder="+XX XXXXX XXXXX"
                      value={formData.whatsapp[0] ? formData.whatsapp[0] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="whatsapp-1"
                      onChange={(e) => handleMultiInput(e, "whatsapp", 1)}
                      id="whatsapp-1"
                      placeholder="+XX XXXXX XXXXX"
                      value={formData.whatsapp[1] ? formData.whatsapp[1] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="whatsapp-2"
                      onChange={(e) => handleMultiInput(e, "whatsapp", 2)}
                      id="whatsapp-2"
                      placeholder="+XX XXXXX XXXXX"
                      value={formData.whatsapp[2] ? formData.whatsapp[2] : ""}
                      className="form-control"
                    />
                  </div>
                  <div className="col-3">
                    <input
                      type="text"
                      name="whatsapp-3"
                      onChange={(e) => handleMultiInput(e, "whatsapp", 3)}
                      id="whatsapp-3"
                      placeholder="WhatsApp 4"
                      value={formData.whatsapp?.[3] ? formData.whatsapp[3] : ""}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row mb_15">
                  <div className="col-2 d_flex d_flex_align_center">
                    <label className="d_flex d_flex_align_center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 496 512"
                      >
                        <path
                          fill="#25a1de"
                          d="M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"
                        />
                      </svg>
                      Telegram{" "}
                    </label>
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="telegram-0"
                      onChange={(e) => handleMultiInput(e, "telegram", 0)}
                      id="telegram-0"
                      placeholder="Telegram..."
                      value={formData.telegram[0] ? formData.telegram[0] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="telegram-1"
                      onChange={(e) => handleMultiInput(e, "telegram", 1)}
                      id="telegram-1"
                      placeholder="Telegram..."
                      value={formData.telegram[1] ? formData.telegram[1] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="telegram-2"
                      onChange={(e) => handleMultiInput(e, "telegram", 2)}
                      id="telegram-2"
                      placeholder="Telegram..."
                      value={formData.telegram[2] ? formData.telegram[2] : ""}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row mb_15">
                  <div className="col-2 d_flex d_flex_align_center">
                    <label className="d_flex d_flex_align_center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="#d82c7e"
                          d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                        />
                      </svg>
                      Instagram{" "}
                    </label>
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="instagram-0"
                      onChange={(e) => handleMultiInput(e, "instagram", 0)}
                      id="instagram-0"
                      placeholder="Instagram..."
                      value={formData.instagram[0] ? formData.instagram[0] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="instagram-1"
                      onChange={(e) => handleMultiInput(e, "instagram", 1)}
                      id="instagram-1"
                      placeholder="Instagram..."
                      value={formData.instagram[1] ? formData.instagram[1] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="instagram-2"
                      onChange={(e) => handleMultiInput(e, "instagram", 2)}
                      id="instagram-2"
                      placeholder="Instagram..."
                      value={formData.instagram[2] ? formData.instagram[2] : ""}
                      className="form-control"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-2 d_flex d_flex_align_center">
                    <label className="d_flex d_flex_align_center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="#00aff0"
                          d="M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
                        />
                      </svg>
                      Skype{" "}
                    </label>
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="skype-0"
                      onChange={(e) => handleMultiInput(e, "skype", 0)}
                      id="skype-0"
                      placeholder="Skype..."
                      value={formData.skype[0] ? formData.skype[0] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="skype-1"
                      onChange={(e) => handleMultiInput(e, "skype", 1)}
                      id="skype-1"
                      placeholder="Skype..."
                      value={formData.skype[1] ? formData.skype[1] : ""}
                      className="form-control"
                    />
                  </div>

                  <div className="col-3">
                    <input
                      type="text"
                      name="skype-2"
                      onChange={(e) => handleMultiInput(e, "skype", 2)}
                      id="skype-2"
                      placeholder="Skype..."
                      value={formData.skype[2] ? formData.skype[2] : ""}
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div> */}

              <div className={`${sectionClass("messages")} card mb-15`}>
                <div className="card_header">Messages</div>
                <div className="card_body social-media">
                  <div className="row mb-15">
                    <div className="col-2 d_flex d_flex_align_center">
                      <label className="d_flex d_flex_align_center">
                        {" "}
                        Maintenance Message{" "}
                      </label>
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) => handleInputChange(e)}
                        name="maintenanceMessage"
                        id="maintenanceMessage"
                        placeholder=""
                        value={formData.maintenanceMessage}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-15">
                    <div className="col-2 d_flex d_flex_align_center">
                      <label className="d_flex d_flex_align_center">
                        {" "}
                        Agent Message{" "}
                      </label>
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) => handleInputChange(e)}
                        name="agentMessage"
                        id="agentMessage"
                        placeholder=""
                        value={formData.agentMessage}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-15">
                    <div className="col-2 d_flex d_flex_align_center">
                      <label className="d_flex d_flex_align_center">
                        {" "}
                        User Message{" "}
                      </label>
                    </div>
                    <div className="col-6">
                      <input
                        type="text"
                        onChange={(e) => handleInputChange(e)}
                        name="userMessage"
                        id="userMessage"
                        placeholder=""
                        value={formData.userMessage}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {false && (
                <>
                  <div className="card mb-15">
                    <div className="card_header">
                      <h2
                        className="card-title m-0"
                        style={{ fontWeight: "normal" }}
                      >
                        Cricket Odds Limits
                      </h2>
                    </div>
                    <div className="card_body">
                      <div className="row ">
                        <div className="col-2 card_body_item ">
                          <label htmlFor="currency">Odds Limit:</label>
                          <input
                            className="form-control"
                            placeholder="Max"
                            name="max"
                            onChange={(e) => handleCricketMinMax(e, "oddsLimit")}
                            type="text"
                            value={formData.cricket?.oddsLimit?.max}
                          />
                        </div>

                        <div className="form-group1 col-1"></div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Bet Odds Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleCricketMinMax(e, "bet_odds_limit")
                                }
                                value={formData.cricket?.bet_odds_limit?.min}
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleCricketMinMax(e, "bet_odds_limit")
                                }
                                value={formData.cricket?.bet_odds_limit?.max}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Bookmaker Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleCricketMinMax(e, "bet_bookmaker_limit")
                                }
                                value={formData.cricket?.bet_bookmaker_limit?.min}
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleCricketMinMax(e, "bet_bookmaker_limit")
                                }
                                value={formData.cricket?.bet_bookmaker_limit?.max}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Fancy Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleCricketMinMax(e, "bet_fancy_limit")
                                }
                                value={formData.cricket?.bet_fancy_limit?.min}
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleCricketMinMax(e, "bet_fancy_limit")
                                }
                                value={formData.cricket?.bet_fancy_limit?.max}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Premium Odds Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleCricketMinMax(e, "bet_premium_limit")
                                }
                                value={formData.cricket?.bet_premium_limit?.min}
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleCricketMinMax(e, "bet_premium_limit")
                                }
                                value={formData.cricket?.bet_premium_limit?.max}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card mb-15">
                    <div className="card_header">
                      <h2
                        className="card-title m-0"
                        style={{ fontWeight: "normal" }}
                      >
                        Soccer Odds Limits
                      </h2>
                    </div>
                    <div className="card_body">
                      <div className="row ">
                        <div className="col-2 card_body_item ">
                          <label htmlFor="currency">Odds Limit:</label>
                          <input
                            className="form-control"
                            placeholder="Max"
                            name="max"
                            onChange={(e) => handleSoccerMinMax(e, "oddsLimit")}
                            type="text"
                            value={formData.soccer?.oddsLimit?.max}
                          />
                        </div>

                        <div className="form-group1 col-1"></div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Bet Odds Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleSoccerMinMax(e, "bet_odds_limit")
                                }
                                value={formData.soccer?.bet_odds_limit?.min}
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleSoccerMinMax(e, "bet_odds_limit")
                                }
                                value={formData.soccer?.bet_odds_limit?.max}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Bookmaker Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleSoccerMinMax(e, "bet_bookmaker_limit")
                                }
                                value={formData.soccer?.bet_bookmaker_limit?.min}
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleSoccerMinMax(e, "bet_bookmaker_limit")
                                }
                                value={formData.soccer?.bet_bookmaker_limit?.max}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Premium Odds Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleSoccerMinMax(e, "bet_premium_limit")
                                }
                                value={
                                  formData.soccer?.bet_premium_limit?.min
                                    ? formData.soccer?.bet_premium_limit?.min
                                    : ""
                                }
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleSoccerMinMax(e, "bet_premium_limit")
                                }
                                value={
                                  formData.soccer?.bet_premium_limit?.max
                                    ? formData.soccer?.bet_premium_limit?.max
                                    : ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card_header">
                      <h2
                        className="card-title m-0"
                        style={{ fontWeight: "normal" }}
                      >
                        Tennis Odds Limits
                      </h2>
                    </div>
                    <div className="card_body">
                      <div className="row ">
                        <div className="col-2 card_body_item ">
                          <label htmlFor="currency">Odds Limit:</label>
                          <input
                            className="form-control"
                            placeholder="Max"
                            name="max"
                            onChange={(e) => handleTennisMinMax(e, "oddsLimit")}
                            type="text"
                            value={formData.tennis?.oddsLimit?.max}
                          />
                        </div>

                        <div className="form-group1 col-1"></div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Bet Odds Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleTennisMinMax(e, "bet_odds_limit")
                                }
                                value={formData.tennis?.bet_odds_limit?.min}
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleTennisMinMax(e, "bet_odds_limit")
                                }
                                value={formData.tennis?.bet_odds_limit?.max}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Bookmaker Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleTennisMinMax(e, "bet_bookmaker_limit")
                                }
                                value={formData.tennis?.bet_bookmaker_limit?.min}
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleTennisMinMax(e, "bet_bookmaker_limit")
                                }
                                value={formData.tennis?.bet_bookmaker_limit?.max}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group1 col-2">
                          <label htmlFor="tennis_min_bet_odds_limit">
                            Premium Odds Limit:
                          </label>
                          <div className="row">
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Min"
                                name="min"
                                type="text"
                                onChange={(e) =>
                                  handleTennisMinMax(e, "bet_premium_limit")
                                }
                                value={
                                  formData.tennis?.bet_premium_limit?.min
                                    ? formData.tennis?.bet_premium_limit?.min
                                    : ""
                                }
                              />
                            </div>
                            <div className="form-group1 col-6">
                              <input
                                className="form-control"
                                placeholder="Max"
                                name="max"
                                type="number"
                                onChange={(e) =>
                                  handleTennisMinMax(e, "bet_premium_limit")
                                }
                                value={
                                  formData.tennis?.bet_premium_limit?.max
                                    ? formData.tennis?.bet_premium_limit?.max
                                    : ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="card_footer">
              <input
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{
                  background: isHover
                    ? hexToYIQTextColor(
                      getTheme(DD?.colorSchema)?.backgroundColor || "#000",
                    )
                    : getTheme(DD?.colorSchema)?.backgroundColor,
                  color: isHover
                    ? getTheme(DD?.colorSchema)?.backgroundColor
                    : hexToYIQTextColor(
                      getTheme(DD?.colorSchema)?.backgroundColor || "#000",
                    ),
                  border: `1px solid ${getTheme(DD?.colorSchema)?.backgroundColor}`,
                  height: "33px",
                }}
                className="btn_black"
                type="submit"
                value="Save"
                onClick={(e) => handleSubmitClick(e)}
              />
              <button
                type="button"
                onClick={(e) => handleCancelClick(e)}
                className="btn btn-sm btn-default"
                style={{ marginBottom: 0 }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditWebsites;
